(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-idp/assets/javascripts/react/components/shared/polling-mobile.js') >= 0) return;  svs.modules.push('/modules/iam-idp/assets/javascripts/react/components/shared/polling-mobile.js');


'use strict';

const {
  Fallback
} = svs.iam_idp.components.shared;
const {
  Button
} = svs.ui;
const {
  useEffect
} = React;
const {
  Loader
} = svs.components.ReactLoader;
const {
  useAtom,
  useAtomValue
} = jotai;
const {
  isPollingAtom,
  qrCodeAtom,
  showLoaderAtom,
  showFallbackAtom,
  showFallbackQrAtom
} = svs.iam_idp.atoms;
const {
  isPnp
} = svs.iam_idp.data;
const QRCode = svs.components.libs.ReactQRCode;
const PollingMobile = () => {
  const [isPolling, setIsPolling] = useAtom(isPollingAtom);
  const [showFallback, setShowFallback] = useAtom(showFallbackAtom);
  const [showQr, setShowQr] = useAtom(showFallbackQrAtom);
  const [showLoader, setShowLoader] = useAtom(showLoaderAtom);
  const qr = useAtomValue(qrCodeAtom);
  useEffect(() => {
    let timeout;
    setShowLoader(true);
    if (isPolling) {
      timeout = setTimeout(() => {
        setShowFallback(true);
        setShowLoader(false);
      }, 5000);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [isPolling, setShowFallback, setShowLoader]);
  const contentToRender = () => {
    if (showQr) {
      return React.createElement("div", {
        className: "iam-idp-qr-code-container"
      }, React.createElement(QRCode, {
        includeMargin: false,
        size: 120,
        value: qr
      }));
    } else if (showFallback) {
      return React.createElement(Fallback, null);
    } else if (showLoader) {
      return React.createElement("div", {
        className: "spinner-container"
      }, React.createElement("p", {
        className: "spinner-container-text"
      }, "V\xE4ntar p\xE5 identifiering i app"), React.createElement(Loader, {
        inverted: !isPnp
      }));
    }
    return null;
  };
  return React.createElement("div", null, contentToRender(), React.createElement(Button, {
    block: true,
    className: "",
    inverted: isPnp,
    onClick: () => {
      svs.accountservices.authenticate.login.cancel();
      setIsPolling(false);
      setShowFallback(false);
      setShowQr(false);
      setShowLoader(false);
    },
    size: 300,
    transparent: true
  }, "Avbryt"));
};
svs.iam_idp.components.shared.PollingMobile = PollingMobile;

 })(window);